export default {
    props: {
        toolbarToolbarItemName: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.toolbarItem.name'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/Toolbar.js